import "./PayrollCard.css";

const PayrollCard = ({ title, subTitle, subTitleValue, amount, dotClassName }) => {
  return (
    <div className="payroll-card">
      <div className="payroll-card-header">
        <div className="dot">
            <span className={dotClassName}></span>
        </div>
        <span className="title">{title}</span>
      </div>
      <div className="payroll-content">
        <span className="label">{subTitle} : {subTitleValue} </span>
        <span className="amount">&#8377; {amount}</span>
      </div>
    </div>
  );
};

export default PayrollCard;
